import { render, staticRenderFns } from "./hrd-trainer-detail.vue?vue&type=template&id=cddeea76"
import script from "./hrd-trainer-detail.vue?vue&type=script&lang=js"
export * from "./hrd-trainer-detail.vue?vue&type=script&lang=js"
import style0 from "./hrd-trainer-detail.vue?vue&type=style&index=0&id=cddeea76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports